import {
    SET_CUSTOMERS_DATA_LOADING,
    SET_CUSTOMERS,
    SET_SEARCH_CUSTOMERS,
    SET_SEARCH_CUSTOMER_BY_ID,
} from "../actions/types";

const initialState = {
    isLoading: false,
    customersData: [],
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        limit: 10,
        hasNextPage: false,
        hasPrevPage: false,
        nextPage: null,
        prevPage: null,
    },
    searchedCustomers: [],
    searchedCustomerById: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_CUSTOMERS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_CUSTOMERS:
            return {
                ...state,
                customersData: payload.data,
                pagination: payload.pagination,
                isLoading: false,
            };
        case SET_SEARCH_CUSTOMERS:
            return {
                ...state,
                searchedCustomers: payload,
            };
        case SET_SEARCH_CUSTOMER_BY_ID:
            return {
                ...state,
                searchedCustomerById: payload,
            };
        default:
            return state;
    }
}
